import React, { ErrorInfo } from 'react';
import { ErrorPage } from 'shared-components';

interface Props {
  children?: React.ReactNode;
}
export class ErrorBoundary extends React.PureComponent<Props, { error?: Error; errorInfo?: ErrorInfo }> {
  constructor(props: Props) {
    super(props);
    this.state = { error: undefined, errorInfo: undefined };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    if (error !== this.state.error || errorInfo !== this.state.errorInfo) {
      this.setState({
        error: error,
        errorInfo: errorInfo
      });
    }
  }

  render(): React.ReactNode {
    if (this.state.errorInfo) {
      return <ErrorPage errorCode="500" />;
    }
    return this.props.children;
  }
}
